// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"MessageList_messageContainer__c1R7B"};